export default {
    intCodigoRetorno: 0,
    isError: false,
    isTokenError: false,
    strErrorMessage: '',
    vchVersaoParametros: null,
    arrJogo: [
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 140,
        numPremio: 0,
        numValor: 1.11,
        numValorApostas: 2.22,
        numValorTotal: 1.11,
        sdtDataCobrancaJI: '2019-02-08 00:00',
        sdtDataHora: '2019-02-08 09:52',
        sdtDataJogo: '2019-02-13',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: '6022119141051394',
        vchDescricao: 'SUPER 6',
        vchETicket: '999000000001000140',
        vchNumero: '02071425293038434459',
        vchPremio: '1.6',
        vchTipoJogo: 'Super 6'
      },
      {
        bitCancelada: 0,
        chrSerial: '999000000001',
        intNumeroPule: 140,
        numPremio: 0,
        numValor: 1.11,
        numValorApostas: 2.22,
        numValorTotal: 1.11,
        sdtDataCobrancaJI: '2019-02-08 00:00',
        sdtDataHora: '2019-02-08 09:52',
        sdtDataJogo: '2019-02-13',
        sntQuantidadeApostas: 2,
        vchCodigoSeguranca: '6022119141051394',
        vchDescricao: 'SUPER 6',
        vchETicket: '999000000001000140',
        vchNumero: '19212839434446475158',
        vchPremio: '1.6',
        vchTipoJogo: 'Super 6'
      }
    ]
  }


// WEBPACK FOOTER //
// ./src/mocking/detalhe-aposta-retorno.js